<template>
  <div
    :class="[
      'organism accordion',
      'container-' + organism.containerWidth,
      organism.removeMargin,
    ]"
  >
    <div
      v-for="(item, index) in organism.item"
      :key="'item-' + index"
      :id="item.id"
      :class="[
        item.cssClasses,
        'mx-auto max-w-screen-xl border-b last:border-b-0 border-gray-400 py-10 px-4',
      ]"
    >
      <h3
        class="accordion-header font-archer text-xl md:text-[28px] font-semibold text-bc-blue"
      >
        <button
          :aria-expanded="expanded[index] ? 'true' : 'false'"
          :aria-controls="'accordion-content-' + index"
          class="grid grid-cols-[1fr_2rem] items-center w-full text-left cursor-pointer text-bc-blue hover:opacity-80"
          @click="toggle(index)"
        >
          <div class="flex flex-col">
            <span class="text-2xl md:text-[28px] title">{{ item.title1 }}</span>
            <span
              v-if="item.title2"
              class="text-base font-medium text-gray-400 md:text-lg subtitle font-ubuntu"
              >{{ item.title2 }}</span
            >
          </div>
        </button>
      </h3>
      <div
        class="accordion-content overflow-hidden transition-[max-height] duration-300 aria-hidden:max-h-0 max-h-[1000px]"
        :id="'accordion-content-' + index"
        :aria-hidden="expanded[index] ? 'false' : 'true'"
      >
        <div
          v-html="item.description"
          class="text-gray-500 description mt-7"
        ></div>
        <MoleculesButtons
          v-if="item.button1"
          :buttons="item"
          :button-colors="[
            item.button1Color ?? 'button-blue',
            item.button2Color ?? 'button-white',
            item.button3Color ?? 'button-white',
          ]"
        />
      </div>
    </div>
  </div>
</template>

<style>
.accordion {
  .accordion-header {
    button {
      &::after {
        @apply w-7 h-7 bg-no-repeat block bg-contain;
        content: "";
        background-image: url("/img/heroicon-plus-circle--blue.png");
      }
      &[aria-expanded="true"]::after {
        background-image: url("/img/heroicon-minus-circle--blue.png");
      }
    }
  }

  .accordion-content {
    .buttons {
      @apply mt-7 mb-1;
    }

    .description a {
      @apply text-bc-blue;

      span {
        @apply underline;
      }
    }
  }
}
</style>
<script setup>
const props = defineProps({
  organism: Object,
});

const expanded = reactive({});

const toggle = (index) => {
  expanded[index] = !expanded[index];
};

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
